import axiosInstance from "../axiosInstance";
// Endpoint

const getCampaign = id => `/campaign_packages/${id}`;

export const get = (id, data) => axiosInstance.get(getCampaign(id), data);
